module.exports = __webpack_public_path__ + "img/190049f.png";